import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { PageViewer } from "./PageViewer";

export function LotQuestions({ reports, onChanged }) {
  const open = reports.flatMap((r) => (r.questions || []).filter((q) => q.status !== "answered").map((q) => ({ r, q })));
  const [ans, setAns] = useState({});
  const [show, setShow] = useState(null);
  const set = (id, patch) => setAns({ ...ans, [id]: { ...(ans[id] || {}), ...patch } });
  const submit = async () => {
    const body = open.filter(({ q }) => ans[q.id]?.answer?.trim()).map(({ r, q }) => ({ report_id: r.id, question_id: q.id, answer: ans[q.id].answer, reason: ans[q.id].reason || "" }));
    try { const { data } = await api.post("/pm/answers", body); toast.success(`${data.answered} réponse(s) enregistrée(s)`); setAns({}); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!open.length) return <p className="text-sm text-slate-500" data-testid="lot-questions-empty">Aucune question en attente pour ce lot.</p>;
  return (
    <div className="space-y-3" data-testid="lot-questions">
      <p className="text-sm text-slate-600">Répondez en une fois ; les lignes sans ambiguïté continuent leur traitement.</p>
      {open.map(({ r, q }) => (
        <div key={q.id} className="tl-card space-y-2" data-testid={`lot-question-${q.id}`}>
          <div className="text-xs text-slate-500">{r.filename} · page {r.page_no}{r.employee_id && ` · ${r.employee_id}`}{r.work_date && ` · ${r.work_date}`}</div>
          <b>{q.text}</b>
          <button className="text-xs underline ml-2" onClick={() => setShow(show === q.id ? null : q.id)} data-testid={`lot-question-show-${q.id}`}>{show === q.id ? "Masquer la page" : "Voir la page"}</button>
          {show === q.id && <PageViewer fileId={r.file_id} page={r.page_no} />}
          <div className="grid sm:grid-cols-2 gap-2">
            <input className="tl-input" placeholder="Réponse / décision" value={ans[q.id]?.answer || ""} onChange={(e) => set(q.id, { answer: e.target.value })} data-testid={`lot-answer-${q.id}`} />
            <input className="tl-input" placeholder="Motif" value={ans[q.id]?.reason || ""} onChange={(e) => set(q.id, { reason: e.target.value })} data-testid={`lot-reason-${q.id}`} />
          </div>
        </div>
      ))}
      <button className="tl-btn tl-btn-primary" onClick={submit} data-testid="lot-answers-submit">Enregistrer les réponses</button>
    </div>
  );
}
